import { render, staticRenderFns } from "./prize_statistics.vue?vue&type=template&id=19f92109&scoped=true"
import script from "./prize_statistics.vue?vue&type=script&lang=js"
export * from "./prize_statistics.vue?vue&type=script&lang=js"
import style0 from "./prize_statistics.vue?vue&type=style&index=0&id=19f92109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f92109",
  null
  
)

export default component.exports